// removed by extract-text-webpack-plugin
module.exports = {"block":"gTMTVDcuHv009EWHQpnii","link":"_1mcshSv3xcbdU9Hc9nRcis","text":"_1JeJc6_OPwYEWjw_6o5BQt","link-container":"_2OY5RTouu6TzPPPbs7TzNy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DidntFindAnswer/DidntFindAnswer.module.scss
// module id = 748
// module chunks = 0